<template lang="pug">
  v-layout(column fill-height)
    v-flex
      v-card.border-r-0(min-height="130px")
        v-card-text(style="height: 128px;")
          v-layout(align-center justify-center column fill-height)
            v-progress-circular(v-if="isLoading" size="70" width="7" indeterminate)
            animated-number.display-1.font-weight-light(v-if="!isLoading" :value="currentMonthToDate" :formatValue="formatToNumber" :duration="1000")
            div.text-xs-center.caption.font-weight-regular.green--text Month To Date
      v-card(color="#F3F3F3")
        v-card-text
          v-layout(align-center justify-center row fill-height)
            div.text-xs-center.caption(v-if="lastMonthToDate > currentMonthToDate")
              v-icon(small color="red") arrow_downward
              span {{currentMonthPer}}% Decrease
              span ({{lastMonthToDate}})
            div.text-xs-center.caption(v-else)
              v-icon(small color="green") arrow_upward
              span {{currentMonthPer}}% Incresses
              span ({{lastMonthToDate}})
    v-flex
      v-card.border-r-0(min-height="130px" )
        v-card-text(style="height: 128px;")
          v-layout(align-center justify-center column fill-height)
            v-progress-circular(v-if="isLoading" size="70" width="7" indeterminate)
            animated-number.display-1.font-weight-light(v-if="!isLoading" :value="lastMonth" :formatValue="formatToNumber" :duration="1000")
            div.text-xs-center.caption.font-weight-regular.green--text Last Month
      v-card(color="blue-grey lighten-5")
        v-card-text
          v-layout(align-center justify-center row fill-height)
            div.text-xs-center.caption(v-if="monthBeforLastMonth > lastMonth")
              v-icon(small color="red") arrow_downward
              span {{LastMonthPer}}% Decrease
              span ({{monthBeforLastMonth}})
            div.text-xs-center.caption(v-else)
              v-icon(small color="green") arrow_upward
              span {{LastMonthPer}}% Incresses
              span ({{monthBeforLastMonth}})
</template>

<script>
import dashbaordService from '../../service.js'
import AnimatedNumber from "animated-number-vue";

export default {
  data() {
    return {
      currentMonthToDate: 0,
      lastMonth: 0,
      lastMonthToDate: 0,
      monthBeforLastMonth: 0,
      currentMonthPer: 0,
      LastMonthPer: 0,
      isLoading: true
    }
  },
  components: {
    AnimatedNumber
  },
  mounted() {
    this.getSignUpData()
  },
  methods: {
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    getSignUpData() {
      dashbaordService.getSignUpData()
      .then(result => {
        this.currentMonthToDate = result.data.currentMonthToDate
        this.lastMonth = result.data.lastMonth
        this.lastMonthToDate = result.data.lastMonthToDate
        this.monthBeforLastMonth = result.data.monthBeforLastMonth
        var value = result.data.currentMonthToDate - result.data.lastMonthToDate
        this.currentMonthPer = (value / result.data.lastMonthToDate * 100).toFixed(0)
        
        var value2 = result.data.lastMonth - result.data.monthBeforLastMonth
        this.LastMonthPer = (value2 / result.data.monthBeforLastMonth * 100).toFixed(0)
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
</style>